<template>
    <div class="mb-8 space-y-2 max-w-7xl mx-auto">
        <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
            <h4 class="text-lg text-center font-medium">{{ $t('Notifications') }}</h4>
            <div class="flex justify-end"></div>
        </div>

        <ul class="space-y-1">
            <li class="text-sm flex items-center">
                <span class="flex-1 ml-3">ID</span>
                <span class="flex-1">{{ $t('Sender') }}</span>
                <span class="flex-1">{{ $t('To User') }}</span>
                <span class="flex-1">{{ $t('From User') }}</span>
                <span class="flex-1">{{ $t('Event Type') }}</span>
                <span class="flex-1">{{ $t('Read') }}</span>
                <span class="flex-1">{{ $t('Details') }}</span>
                <span class="flex-1">{{ $t('Created') }}</span>
            </li>
            <li v-for="event in events" :key="event.id">
                <EventCard :event="event" />
            </li>
        </ul>

        <spinner v-if="!events && $apollo.queries.events.loading" />
        <div v-else>
            <div v-if="hasMore" class="flex justify-center">
                <button
                    @click="showMore"
                    class="border flex justify-center items-center h-10 w-40 border-gray-400 hover:border-gray-800 text-sm rounded px-3 py-2"
                >
                    <spinner v-if="loadingMore" class="text-white" />
                    <span v-else>{{ $t('Load More') }}</span>
                </button>
            </div>
            <div v-else class="flex justify-center">
                <span>{{ $t('No more items to show') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import gql from 'graphql-tag'
import EventCard from '../components/EventCard'
//@Todo handle error cases and show UI

const EVENTS_QUERY = gql`
    query events($limit: Int!, $offset: Int!) {
        events(limit: $limit, offset: $offset) {
            id
            sender
            toUserId
            eventType
            readAt
            detailJson
            createdAt
        }
    }
`
export default {
    components: {
        EventCard,
    },

    apollo: {
        events: {
            query: EVENTS_QUERY,
            variables: {
                limit: 20,
                offset: 0,
            },
        },
    },
    methods: {
        async showMore() {
            this.loadingMore = true
            this.offset += this.limit
            await this.$apollo.queries.events.fetchMore({
                variables: {
                    limit: this.limit,
                    offset: this.offset,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEvents = fetchMoreResult.events
                    const hasMore = fetchMoreResult.events.length !== 0

                    this.hasMore = hasMore

                    return {
                        events: [...previousResult.events, ...newEvents],
                    }
                },
            })
            this.loadingMore = false
        },
    },
    data() {
        return {
            loadingMore: false,
            limit: 20,
            offset: 0,
            hasMore: true,
        }
    },
    mounted() {
        if (this.$route.query.reload === true) {
            this.$apollo.queries.events.refetch()
            this.$router.push('/events')
        }
    },
}
</script>
